import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { ETooltipPosition } from '@app/core/enums';
import {
    TButtonBorderRadius,
    TButtonColor,
    TButtonHeight,
    TButtonIconPosition,
    TButtonType,
} from '@components/button/constants/button.types';
import { BehaviorSubject } from 'rxjs';

/**
 * Компонент кнопки
 * @package Button
 * @version 1.3
 * @author Dogaeva A.P.
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */

@Component({
    selector: 'fui-button, app-button',
    templateUrl: './button.component.html',
    styleUrls: ['../styles/button.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent implements OnInit {
    /** Флаг загрузки */
    public isLoad$ = new BehaviorSubject<boolean>(false);

    /** === Параметры: Форма ===  */
    /** Тип кнопки */
    @Input() type: TButtonType = 'button-long';
    /** Высота */
    @Input() height: TButtonHeight = 'normal';
    /** Скругления углов */
    @Input() borderRadius: TButtonBorderRadius = 'rounded';

    /** === Параметры: Содержание === */
    /** Цветовая тема */
    @Input() color: TButtonColor = 'primary';
    /** Иконка кнопки (mdi) */
    @Input() icon?: string;
    /** Текст кнопки */
    @Input() label?: string;
    /** Тултип */
    @Input() title?: string;

    /** === Дополнительные параметры === */
    /** @deprecated Размер иконки в пикселях */
    @Input() iconSize?: number;
    /** Размер иконки в ремах */
    @Input() iconSizeRem?: number;
    /** Положение иконки */
    @Input() positionIcon: TButtonIconPosition = 'left';
    /** Расположение тултипа */
    @Input() titlePosition: ETooltipPosition = ETooltipPosition.below;
    /** Цвет текста кнопки */
    @Input() textColor?: string;

    /** Заблокирована ли кнопка */
    @Input() disabled: boolean = false;
    /** Событие клика */
    @Output() clickEvent = new EventEmitter<any>();

    /** Ссылка на кнопку */
    @ViewChild('buttonRef') private _buttonRef: MatButton;

    /** Классы для кнопки */
    public classes: Array<any> = [];

    /** Установить фокус на кнопку */
    public focus(): void {
        // Предупреждение, не надо сюда добавлять timeOut, тут все и без него работает
        this._buttonRef?.focus();
    }

    ngOnInit() {
        this.isLoad$.next(true);
    }
}
